<template>
    <div class="t-time-picker date-picker-container" :class="{ 'enable-clear': enableClear, 'date-picker-inline': inline }">
        <div ref="datePicker">
            <input
                @blur="blur"
                :placeholder="placeholder"
                :name="name"
                :disabled="disabled"
                :class="{ '!cursor-not-allowed': disabled }"
                :value="adjustedValue"
                class="form-control datepicker"
                type="text"
                data-input
            />
            <button @click.prevent="clearInput" class="btn btn-plain" title="clear" v-if="enableClear" data-clear>
                <i class="fal fa-times fa-fw"></i>
            </button>
        </div>
    </div>
</template>

<script>
import flatpickr from 'flatpickr';
import 'flatpickr/dist/themes/airbnb.css';

export default {
    components: {
        flatpickr,
    },

    props: {
        value: {
            required: false,
        },
        placeholder: {
            type: String,
            default: () => {
                return moment().format('LT');
            },
        },
        name: {
            type: String,
            default: 'time',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        format: {
            type: String,
            default: 'LT',
        },
        twelveHourTime: {
            type: Boolean,
            default: null,
        },
        enableClear: {
            type: Boolean,
            default: true,
        },
        inline: {
            type: Boolean,
            default: false,
        },
    },

    //
    // Data
    //
    data() {
        return {
            date: null,
            configuration: {},
        };
    },

    //
    // Computed
    //
    computed: {
        adjustedValue() {
            if (!this.date) {
                return null;
            }

            return this.date;
        },
    },

    //
    // Created
    //
    created() {
        this.loadPicker();
    },

    //
    // Methods
    //
    methods: {
        clearInput() {
            let newVal = null;
            this.$emit('change', newVal);
            this.$emit('input', newVal);
        },
        onChange(newVal) {
            this.$emit('input', moment(newVal[0]).format(this.format));
        },
        loadPicker() {
            this.date = this.value;

            this.$nextTick(() => {
                this.flatpickr = flatpickr(this.$refs.datePicker, {
                    wrap: !this.inline,
                    inline: this.inline,
                    static: true,
                    mode: 'single',
                    enableTime: true,
                    noCalendar: true,
                    onClose: this.onChange,
                    allowInput: true,
                    time_24hr: !(this.twelveHourTime !== null ? this.twelveHourTime : this.localUses12Hour()),
                    dateFormat: this.flatPickrFormat(),
                });
            });
        },
        localUses12Hour() {
            let local = moment().format('LT');
            return local.includes('AM') || local.includes('PM');
        },
        flatPickrFormat() {
            return this.localUses12Hour() ? 'h:i K' : 'H:i';
        },
        blur() {
            this.$emit('blur');
        },
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newVal) {
                Vue.set(this, 'date', newVal);
            },
        },
    },
};
</script>

<style lang="css">
.date-picker-container {
    position: relative;
    width: 100%;
}

.flatpickr-wrapper {
    width: 100%;
}

.flatpickr-calendar.static.open {
    position: absolute;
    top: 100%;
}

.date-label {
    display: none !important;
}
</style>
